export default __webpack_public_path__ + "static/media/sort.9968bb5c.svg";